import React from "react";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";

import ContentCardList from "../../../Components/ContentCardList/ContentCardList";
import PageHeader from "../../../Components/PageHeader/PageHeader";
import {
  MenuPageFeedback,
  MenuPageLoading,
} from "../MenuShared/MenuPageState";
import useHistory from "../../../hooks/PortalAluno/useHistory";
import MenuPageBackLink from "../MenuShared/MenuPageBackLink";
import "../Notifications/styles.css";
import "./styles.css";

const HistoryPage = () => {
  const { data, error, isError, isLoading, isRefetching, refetch } = useHistory();

  if (isLoading) {
    return (
      <section className="content-page history-page">
        <MenuPageLoading label="Carregando histórico" />
      </section>
    );
  }

  if (isError && !data) {
    return (
      <section className="content-page history-page">
        <PageHeader title="Histórico" />
        <MenuPageFeedback
          title="Não foi possível carregar seu histórico"
          message={
            error instanceof Error && error.message !== "Network Error"
              ? error.message
              : "Verifique sua conexão e tente novamente."
          }
          onRetry={() => refetch()}
        />
      </section>
    );
  }

  const cards = data ?? [];

  return (
    <section className="content-page history-page" aria-label="Histórico">
      <MenuPageBackLink />

      <div className="menu-page-heading-row">
        <PageHeader
          title="Histórico"
          description="Reveja os conteúdos que você já acessou e continue aprendendo."
        />
        <button
          type="button"
          className="menu-page-refresh"
          onClick={() => refetch()}
          disabled={isRefetching}
        >
          <RefreshRoundedIcon aria-hidden="true" />
          <span>{isRefetching ? "Atualizando…" : "Atualizar"}</span>
        </button>
      </div>

      {cards.length > 0 ? (
        <ContentCardList
          title="Conteúdos acessados"
          cards={cards}
        />
      ) : (
        <MenuPageFeedback
          empty
          title="Seu histórico está vazio"
          message="Os conteúdos que você acessar aparecerão aqui."
        />
      )}
    </section>
  );
};

export default HistoryPage;
